module.exports = __webpack_public_path__ + "img/2.de73a370.jpg";